module.exports = __webpack_public_path__ + "img/icon-arrow-down-white.da52a352.svg";